import React, { useContext, useRef, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { CButton, CCard, CCol, CFormCheck } from '@coreui/react'
import './content.scss'
import PricedIcon from 'src/assets/Content-Icons/PNGs/priced-icon.png'
import FreeGiftIcon from 'src/assets/Content-Icons/PNGs/free-gift-icon.png'
import RocketIcon from 'src/assets/Content-Icons/PNGs/rocket-icon-publish.png'
import CalendarIcon from 'src/assets/Content-Icons/PNGs/calendar-icon-publish.png'
import SaveIcon from 'src/assets/Content-Icons/PNGs/save-icon-publish.png'
import DateIcon from 'src/assets/Content-Icons/dateicon'
import CautionIcon from 'src/assets/caution-icon.svg'
import { getSubscriptionAction } from '../../../Redux/Actions/pricingAction'
import {
  concatDateTimeToIso,
  isEmpty,
  masterAndChildIntersection,
  raiseToast,
} from '../../utils/helper'
import { GlobalContext } from '../../context/GlobalState'
import moment from 'moment-timezone'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { AppContext } from 'src/views/context/app'
import { checkPermissions } from '../../utils/helper'
import CustomMultiSelect from 'src/components/customMultiSelect/customMultiSelect'
import './Calendar.css'
import DatePicker from 'react-date-picker'
import TimePicker from 'src/components/timePicker/timePicker'
import { validateContents } from './ValidateContent'
import IPTVContentSlot from './IPTVContentSlot'
import useAxios from 'axios-hooks'
import { IPTV_CHANNEL_FILTER, IPTV_CHANNEL_API, CONTENT_LIST_API } from 'src/views/utils/urls'
import ToggleButtons from 'src/components/toggleButtons/toggleButtons'

const PricingAndPublish = (props) => {
  const { isEdit, details, cancelModal } = props
  const dispatch = useDispatch()
  const content = useSelector((state) => state.contentReducer)

  console.log('Pricing', content)

  const [isRestricted, setRestricted] = useState(true)
  const [pricingModel, setPricingModel] = useState(['SUBSCRIPTION'])

  const [subscriptions, setSubscriptions] = useState([])
  const [allSubscriptions, setAllSubscriptions] = useState([])

  const [ppv, setPpv] = useState([])
  const [allPpv, setAllPpv] = useState([])

  const [publishPolicy, setPublishPolicy] = useState('')
  const [scheduledDate, setScheduledDate] = useState(new Date())
  const [scheduledTime, setScheduledTime] = useState('')
  const [expiryEnable, setExpiryEnable] = useState(false)
  const [expiryDate, setExpiryDate] = useState('')
  const [expiryTime, setExpiryTime] = useState(
    new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
  )
  const [liveExpiryDate, setLiveExpiryDate] = useState('')
  const [liveExpiryTime, setLiveExpiryTime] = useState('')

  const [errorData, setErrorData] = useState({})
  const [successRedirect, setSuccessRedirect] = useState(false)
  // const [videoType, setVideoType] = useState('')
  const [channelsMaster, setChannelsMaster] = useState([])

  const [isLoginRequired, setIsLoginRequired] = useState(false)

  const { accountObj } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const language = localStorage.getItem('language')

  const createAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.CONTENT.CREATE) &&
    language === accountObj?.default_language
  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.CONTENT.UPDATE,
  )

  const [{ data: channelList }, channelListCall] = useAxios(
    {
      url: IPTV_CHANNEL_FILTER,
      method: 'post',
    },
    {
      manual: true,
    },
  )
  const [{ data: validateSlot }, validateSlotCall] = useAxios(
    {
      url: `${IPTV_CHANNEL_API}/validate-slot`,
      method: 'post',
    },
    {
      manual: true,
    },
  )

  const [{ loading: createContentLoading }, createContent] = useAxios(
    {
      url: CONTENT_LIST_API,
      method: 'post',
    },
    {
      manual: true,
    },
  )

  const [{ loading: updateContentLoading }, updateContent] = useAxios(
    {
      url: CONTENT_LIST_API,
      method: 'put',
    },
    {
      manual: true,
    },
  )

  useEffect(() => {
    channelListCall({
      data: {
        filters: { status: true },
        order_by: 'modified_date',
        reverse: true,
        page: 1,
        page_size: 1000,
      },
    })
  }, [])

  useEffect(() => {
    if (channelList && channelList.success) {
      setChannelsMaster(channelList.data)
    }
  }, [channelList])

  const [iptvslotErrorData, setIptvslotErrorData] = useState([''])
  // const [channelSelectErrorArray, setChannelSelectErrorArray] = useState([])

  const [iptvScheduleData, setIptvScheduleData] = useState([
    {
      channel_id: '',
      start_time: concatDateTimeToIso(
        new Date(),
        new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
      ),
      end_time: concatDateTimeToIso(
        new Date(),
        new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
      ),
      repeat_policy: 'NO_REPEAT',
      expires_on: '',
    },
  ])

  useEffect(() => {
    if (isEdit && !isEmpty(details) && details?.video_type) {
      if (details?.video_type === 'IPTV') {
        setIptvScheduleData(JSON.parse(JSON.stringify(details?.iptv_data?.schedule_data)))
      }
      onEditPricing(details)
      onEditPublish(details)
    } else if (!isEdit) {
      setScheduledTime(
        new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
      )
      setLiveExpiryTime(
        new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
      )
    }
  }, [isEdit, details, allSubscriptions, allPpv])

  const onEditPublish = (details) => {
    setPublishPolicy(details?.publish_policy ? details['publish_policy'] : '')

    if (details?.publish_time) {
      setScheduledDate(new Date(details['publish_time'] + 'Z'))
      setScheduledTime(
        new Date(details['publish_time'] + 'Z').toLocaleTimeString('en-UK', {
          timeStyle: 'short',
          hour12: false,
        }),
      )
      // setScheduledTime(
      //   new Date(details['publish_time'] + 'Z').toLocaleTimeString('en-US', { timeStyle: 'short', hour12: false })),
    }

    setExpiryEnable(!isEmpty(details?.expiry_time))
    if (details?.expiry_time) {
      setExpiryDate(details?.expiry_time ? new Date(details['expiry_time'] + 'Z') : '')
      setExpiryTime(
        new Date(details['expiry_time'] + 'Z').toLocaleTimeString('en-UK', {
          timeStyle: 'short',
          hour12: false,
        }),
      )
    }
    if (details?.live_expiry_time) {
      setLiveExpiryDate(
        details?.live_expiry_time ? new Date(details['live_expiry_time'] + 'Z') : '',
      )
      setLiveExpiryTime(
        new Date(details['live_expiry_time'] + 'Z').toLocaleTimeString('en-UK', {
          timeStyle: 'short',
          hour12: false,
        }),
      )
    }
  }

  const onEditPricing = (details) => {
    setRestricted(details?.is_restricted ? true : false)
    setIsLoginRequired(details?.is_login_required ? true : false)
    setPricingModel(details?.pricing_model ? details['pricing_model'] : [])
    if (!details?.is_restricted) return

    if (details['pricing_model'] && details['pricing_model'].includes('SUBSCRIPTION')) {
      setSubscriptions(masterAndChildIntersection(allSubscriptions, details?.active_subscription))
    } else {
      setSubscriptions([])
    }

    if (details['pricing_model'] && details['pricing_model'].includes('PPV')) {
      setPpv(masterAndChildIntersection(allPpv, details?.active_ppv))
    } else {
      setPpv([])
    }
  }

  useEffect(() => {
    setPublishPolicy(`${content?.video_type}`.includes('LIVE') ? 'SCHEDULED' : 'IMMEDIATE')
  }, [content.video_type])

  const handlePublishPolicy = (event) => {
    let temp = {
      date: '',
    }
    setErrorData({ ...errorData, ...temp })
    let value = event.target.value
    setPublishPolicy(value)
  }

  const handleExpiryDate = () => {
    if (expiryEnable) {
      setExpiryDate('')
      setExpiryTime(new Date().toLocaleTimeString('en-US', { timeStyle: 'short', hour12: false }))
    }
    setExpiryEnable(!expiryEnable)
  }

  useEffect(() => {
    getSubscription()
  }, [])

  useEffect(() => {
    if (content?.video_type === 'IPTV') {
      handleRestriction(false)
    }
  }, [content])

  const getSubscription = async () => {
    const res = await dispatch(getSubscriptionAction())
    if (res?.data?.success) {
      const subs = res.data.data.filter((item) => item.status)
      setAllSubscriptions(subs.filter((item) => item.type === 'normal'))
      setSubscriptions(subs.filter((item) => item.type === 'normal'))
      setAllPpv(subs.filter((item) => item.type === 'ppv'))
      // setPpv(subs.filter((item) => item.type === 'ppv'))
    }
  }

  const handlePricingMethod = (value) => {
    if (value === 'subscription') {
      setPricingModel(['SUBSCRIPTION'])

      setSubscriptions(subscriptions)
      setPpv([])
    }
    if (value === 'payperview') {
      setPricingModel(['PPV'])

      setPpv(ppv)
      setSubscriptions([])
    }
    if (value === 'both') {
      setPricingModel(['SUBSCRIPTION', 'PPV'])

      setSubscriptions(subscriptions)

      setPpv(ppv)
    }
  }

  const handleRestriction = (value) => {
    setRestricted(value)
    if (value) {
      handlePricingMethod('subscription')
    } else {
      setSubscriptions([])

      setPpv([])
      setPricingModel([])
    }
  }

  const handleClearError = (field) => {
    if (errorData && errorData[field]) {
      errorData[field] = ''
    }
  }

  const validateInfo = async () => {
    let isFormValid = true

    let temp = {
      subscription: '',
      ppv: '',
      expiryDate: '',
      date: '',
    }
    if (pricingModel.includes('SUBSCRIPTION') && isRestricted && subscriptions.length === 0) {
      isFormValid = false
      temp.subscription = 'ADD Subscription!'
    }
    if (pricingModel.includes('PPV') && isRestricted && ppv.length === 0) {
      isFormValid = false
      temp.ppv = 'ADD PPV!'
    }

    if (expiryEnable && !expiryDate) {
      isFormValid = false
      temp.expiryDate = 'Select Expiry Date!'
    }

    if (publishPolicy === 'SCHEDULED' && !scheduledDate) {
      isFormValid = false
      temp.date = content.video_type === 'LIVE' ? 'Select live start date' : 'Select Date time!'
    }

    if (
      publishPolicy === 'SCHEDULED' &&
      moment(concatDateTimeToIso(liveExpiryDate, liveExpiryTime)) <
        moment(concatDateTimeToIso(scheduledDate, scheduledTime)) &&
      content.video_type !== 'VOD_LIVE'
    ) {
      isFormValid = false
      temp.date = 'End Date should be greater than start date !'
    }

    if (publishPolicy === 'SCHEDULED' && !liveExpiryDate && content.video_type === 'LIVE') {
      isFormValid = false
      temp.date = 'Please provide live end date'
    }

    if (
      expiryEnable &&
      publishPolicy === 'SCHEDULED' &&
      moment(expiryDate) < moment(scheduledDate)
    ) {
      isFormValid = false
      temp.expiryDate = 'Expiry Date cannot be less than Publish Date!'
    }

    if (content.video_type === 'IPTV') {
      isFormValid = await handleIPTVVAlidations()
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleIPTVVAlidations = async () => {
    let errorArr = iptvslotErrorData
    let flag = true
    for (let i = 0; i < iptvScheduleData.length; i++) {
      const scheduleData = iptvScheduleData[i]
      if (!scheduleData.channel_id) {
        flag = false
        errorArr[i] = 'Please Select a Channel.'
        continue
      }

      if (moment(scheduleData.end_time).diff(moment(scheduleData.start_time), 'minutes') < 5) {
        flag = false
        errorArr[i] = 'Time Difference should be atleast 5 minutes.'
        continue
      }
      if (scheduleData.repeat_policy !== 'NO_REPEAT' && !scheduleData.expires_on) {
        flag = false
        errorArr[i] = 'Please Select a expiry date.'
        continue
      }
      let sameChannelSlots = iptvScheduleData.filter(
        (info, idx) => info.channel_id === scheduleData.channel_id && idx !== i,
      )

      if (sameChannelSlots.length > 0) {
        let conflictFlag = false
        for (let sameChannelIdx = 0; sameChannelIdx < sameChannelSlots.length; sameChannelIdx++) {
          const sameChannel = sameChannelSlots[sameChannelIdx]
          if (
            moment(scheduleData.start_time).isSame(moment(sameChannel.start_time)) ||
            moment(scheduleData.end_time).isSame(moment(sameChannel.end_time)) ||
            moment(scheduleData.start_time).isBetween(
              moment(sameChannel.start_time),
              moment(sameChannel.end_time),
            ) ||
            moment(scheduleData.end_time).isBetween(
              moment(sameChannel.start_time),
              moment(sameChannel.end_time),
            )
          ) {
            conflictFlag = true
            break
          }
        }
        if (conflictFlag) {
          flag = false
          errorArr[i] = 'Time conflict in same channel.'
          continue
        }
      }

      let editScheduleData = details?.iptv_data?.schedule_data[i]
      if (
        isEdit &&
        editScheduleData &&
        scheduleData.channel_id === editScheduleData?.channel_id &&
        scheduleData.start_time === editScheduleData?.start_time &&
        scheduleData.end_time === editScheduleData?.end_time &&
        scheduleData.repeat_policy === editScheduleData?.repeat_policy
      ) {
        continue
      }

      let validateSlotRes = await validateSlotCall({
        params: { channel_id: scheduleData.channel_id },
        data: {
          start_time: scheduleData.start_time,
          end_time: scheduleData.end_time,
          repeat_policy: scheduleData.repeat_policy,
          expires_on: scheduleData.expires_on,
        },
      })

      if (validateSlotRes.data.data.has_conflict) {
        if (isEdit && validateSlotRes?.data?.data?.conflicting_slot?.content_id === details._id) {
          continue
        }
        flag = false
        errorArr[i] = 'Resolve time slot conflict.'
        continue
      }

      errorArr[i] = ''
    }
    setIptvslotErrorData([...errorArr])
    return flag
  }

  const handlePublish = async () => {
    if ((!isEdit && !createAllowed) || (isEdit && !updateAllowed))
      return raiseToast('error', 'Insufficient Permissions or Select Default Language!!')
    let data = {}

    if ((await validateInfo()) && validateContents(content)) {
      data = {
        ...content,
        is_restricted: isRestricted,
        pricing_model: pricingModel,
        active_subscription: subscriptions,
        active_ppv: ppv,
        is_login_required: isRestricted ? true : isLoginRequired,
        publish_policy: publishPolicy,
        publish_time:
          publishPolicy === 'IMMEDIATE'
            ? moment(Date()).toISOString()
            : concatDateTimeToIso(scheduledDate, scheduledTime),
        expiry_time: expiryEnable ? concatDateTimeToIso(expiryDate, expiryTime) : '',
        live_expiry_time:
          `${content?.video_type}` === 'LIVE'
            ? concatDateTimeToIso(liveExpiryDate, liveExpiryTime)
            : '',
      }
      if (`${content?.video_type}` === 'IPTV') {
        data['iptv_data'] = { schedule_data: iptvScheduleData }
      }

      let res = isEdit
        ? await updateContent({
            params: { content_id: details._id },
            data: data,
          })
        : await createContent({ data: data })

      if (res?.data?.success) {
        raiseToast('success', isEdit ? 'Updated Successfully' : 'Created Successfully!!')

        dispatch({ type: 'EMPTY_CONTENT' })
        setTimeout(() => {
          setSuccessRedirect(true)
        }, 500)
      } else {
        raiseToast('error', res?.data?.error)
      }
    } else if (!validateContents(content)) {
      raiseToast('error', 'Fill All Details!!')
    }
  }

  const handleAddSlot = () => {
    setIptvslotErrorData((prev) => [...prev, ''])
    setIptvScheduleData((prev) => [
      ...prev,
      {
        channel_id: '',
        start_time: concatDateTimeToIso(
          new Date(),
          new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
        ),
        end_time: concatDateTimeToIso(
          new Date(),
          new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
        ),
        repeat_policy: 'NO_REPEAT',
        expires_on: '',
      },
    ])
  }

  const handleRemoveSlot = (index) => {
    let tempArr = iptvScheduleData.filter((ele, idx) => idx !== index)
    let tempErrArr = iptvslotErrorData.filter((ele, idx) => idx !== index)
    setIptvScheduleData([...tempArr])
    setIptvslotErrorData([...tempErrArr])
  }

  return (
    <>
      {successRedirect ? <Redirect to="/content" /> : null}
      <CCard style={{ padding: content.video_type === 'IPTV' ? '0 2.5vw' : '0 3.5vw' }}>
        <div className="mt-5 mb-3">
          {content.video_type === 'IPTV' ? (
            <div
              className="rounded-1"
              style={{
                padding: '2vw 2%',
                backgroundColor: '#eeeeee',
                border: 'solid 0.5px #707070',
                boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.31)',
                display: 'flex',
                alignItems: 'center',
                color: '#191818',
              }}
            >
              <h4 style={{ fontSize: '1.5vw', fontWeight: '700' }} className="d-inline-block">
                PRICING
              </h4>
              <h6 className="d-inline-block" style={{ fontSize: '.8vw', marginLeft: '3vw' }}>
                For IPTV contents, Channel pricing will be applied.
              </h6>
            </div>
          ) : (
            <div
              className="rounded-1 py-3"
              style={{
                padding: '1rem 4%',
                backgroundColor: '#eeeeee',
                border: 'solid 0.5px #707070',
                boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.31)',
              }}
            >
              <h4 style={{ fontSize: '1.5vw', fontWeight: '700' }}>SET PRICING</h4>
              <p style={{ fontSize: '12px' }}>
                Please be sure that appropriate Pricing settings are already done. Otherwise go to
                the Pricing for more settings.
              </p>
              <div className="py-4 border-bottom-1 border-bottom-secondary border-bottom">
                <div className="d-flex justify-content-start align-items-center">
                  <h4 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                    Access method
                  </h4>
                  <div
                    className="mx-5 d-flex justify-content-start align-items-center rounded-1 overflow-hidden"
                    style={{ border: '0.5px solid #707070' }}
                  >
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        height: '2.13vw',
                        backgroundColor: isRestricted ? '#000' : '#fff',
                        color: isRestricted ? '#fff' : '#000',
                        padding: '8px 26px',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleRestriction(true)}
                    >
                      <img
                        src={PricedIcon}
                        alt=""
                        className="h-100"
                        style={{ filter: isRestricted ? 'invert(0)' : 'invert(1)' }}
                      />
                      <p
                        style={{
                          marginLeft: '1em',
                          marginBlock: '0',
                          fontWeight: isRestricted ? '600' : '400',
                          fontSize: '.75vw',
                        }}
                      >
                        PAID
                      </p>
                    </div>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        height: '2.13vw',
                        color: isRestricted ? '#000' : '#fff',
                        backgroundColor: isRestricted ? '#fff' : '#000',
                        padding: '8px 26px',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleRestriction(false)}
                    >
                      <img
                        src={FreeGiftIcon}
                        alt=""
                        className="h-100"
                        style={{ filter: isRestricted ? 'invert(0)' : 'invert(1)' }}
                      />
                      <p
                        style={{
                          marginLeft: '1em',
                          marginBlock: '0',
                          fontWeight: isRestricted ? '400' : '600',
                          fontSize: '.75vw',
                        }}
                      >
                        FREE
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="py-4">
                <div className="d-flex justify-content-start align-items-center">
                  <h4 style={{ fontSize: '.8vw', marginBottom: '.2vw', width: '22%' }} className="">
                    Select the Pricing method
                  </h4>
                  <div
                    className=" d-flex justify-content-start align-items-center rounded-1 overflow-hidden"
                    style={{ border: '0.5px solid #707070' }}
                  >
                    <CCol>
                      <CFormCheck
                        className="pricing-cformcheck"
                        type="radio"
                        id="flexRadioDefault1"
                        label="SUBSCRIPTION"
                        value="subscription"
                        checked={pricingModel.includes('SUBSCRIPTION') && pricingModel.length === 1}
                        onChange={(e) => handlePricingMethod(e.target.value)}
                        disabled={!isRestricted}
                      />
                    </CCol>
                    <CCol className="center-form-check">
                      <CFormCheck
                        className="pricing-cformcheck"
                        type="radio"
                        id="flexRadioDefault2"
                        label="PAY-PER-VIEW"
                        value="payperview"
                        checked={pricingModel.includes('PPV') && pricingModel.length === 1}
                        onChange={(e) => handlePricingMethod(e.target.value)}
                        disabled={!isRestricted}
                      />
                    </CCol>
                    <CCol>
                      <CFormCheck
                        className="pricing-cformcheck"
                        type="radio"
                        id="flexRadioDefault3"
                        label="BOTH"
                        value="both"
                        checked={pricingModel.length === 2}
                        onChange={(e) => handlePricingMethod(e.target.value)}
                        disabled={!isRestricted}
                      />
                    </CCol>
                  </div>
                </div>
                {!isRestricted && (
                  <div
                    style={{ marginTop: '.95vw' }}
                    className="d-flex justify-content-start align-items-center"
                  >
                    <h4
                      style={{ fontSize: '.8vw', marginBottom: '.2vw', width: '22%' }}
                      className=""
                    >
                      Login Required
                    </h4>
                    <div className="" style={{ width: '25%' }}>
                      <ToggleButtons
                        toggle={isLoginRequired}
                        setToggle={setIsLoginRequired}
                        trueOption={'Yes'}
                        falseOption={'No'}
                        toggleWidth="58%"
                        btnStyles={{ height: '2.13vw', fontSize: '14.4px' }}
                      />
                    </div>
                  </div>
                )}
                <div
                  style={{ marginTop: '.95vw', gap: '0 2vw', marginBottom: '6vw' }}
                  className="d-flex"
                >
                  {pricingModel.includes('SUBSCRIPTION') && pricingModel.length === 1 && (
                    <div className="w-50">
                      <h6 style={{ fontSize: '.8vw', marginBottom: '.45vw' }} className="">
                        Select the Subscription Plan
                      </h6>
                      <CustomMultiSelect
                        selectedValue={subscriptions}
                        optionsData={allSubscriptions}
                        onChange={setSubscriptions}
                        labelKey="name"
                      />
                    </div>
                  )}
                  {pricingModel.includes('PPV') && pricingModel.length === 1 && (
                    <div className="w-50">
                      <h6 style={{ fontSize: '.8vw', marginBottom: '.45vw' }} className="">
                        Select the Pay-per-View Plan
                      </h6>
                      <CustomMultiSelect
                        selectedValue={ppv}
                        optionsData={allPpv}
                        onChange={setPpv}
                        labelKey="name"
                      />
                    </div>
                  )}
                  {pricingModel.length === 2 && (
                    <>
                      <div className="w-50">
                        <h6 style={{ fontSize: '.8vw', marginBottom: '.45vw' }} className="">
                          Select the Subscription Plan
                        </h6>
                        <CustomMultiSelect
                          selectedValue={subscriptions}
                          optionsData={allSubscriptions}
                          onChange={setSubscriptions}
                          labelKey="name"
                        />
                      </div>
                      <div className="w-50">
                        <h6 style={{ fontSize: '.8vw', marginBottom: '.45vw' }} className="">
                          Select the Pay-per-View Plan
                        </h6>
                        <CustomMultiSelect
                          selectedValue={ppv}
                          optionsData={allPpv}
                          onChange={setPpv}
                          labelKey="name"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          {content.video_type === 'IPTV' ? (
            <div
              className="rounded-1 py-3 mt-4"
              style={{
                padding: '1rem 1%',
                minHeight: '195px',
                backgroundColor: '#eeeeee',
                border: 'solid 0.5px #707070',
                boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.31)',
                color: '#191818',
              }}
            >
              <div className="d-flex align-items-center " style={{ padding: '0 1%' }}>
                <h4 style={{ fontSize: '1.5vw', fontWeight: '700' }}>PUBLISH</h4>
                {iptvslotErrorData.filter((str) => str.length > 0).length > 0 ? (
                  <div style={{ color: '#d80101' }} className="message-text mb-2 mx-4 h-100 d-flex">
                    <img src={CautionIcon} alt="caution" />
                    <p className="mx-2">Resolve Issues to move forward.</p>
                  </div>
                ) : null}
              </div>
              <div className="d-flex justify-content-between" style={{ padding: '0 1%' }}>
                <div className="d-flex justify-content-between" style={{ width: '75%' }}>
                  <h6 style={{ fontSize: '.8vw', marginTop: '.75rem' }}>
                    Set your asset publishing time
                  </h6>
                  <div
                    className="d-flex justify-content-start align-items-center rounded-1 overflow-hidden"
                    style={{ border: '0.5px solid #707070', marginLeft: 'auto' }}
                  >
                    {!`${content?.video_type}`.includes('LIVE') && (
                      <CCol className="cursor-pointer">
                        <CFormCheck
                          className="pricing-cformcheck cursor-pointer"
                          type="radio"
                          id="1"
                          label="PUBLISH NOW"
                          value="IMMEDIATE"
                          checked={publishPolicy === 'IMMEDIATE'}
                          onClick={(e) => handlePublishPolicy(e)}
                        />
                      </CCol>
                    )}
                    <CCol className="cursor-pointer">
                      <CFormCheck
                        className="pricing-cformcheck cursor-pointer"
                        type="radio"
                        id="3"
                        label="SAVE IN DRAFT"
                        value="DRAFT"
                        checked={publishPolicy === 'DRAFT'}
                        onChange={(e) => handlePublishPolicy(e)}
                      />
                    </CCol>
                  </div>
                </div>
                <div style={{ width: '20%', textAlign: 'right' }}>
                  <CButton
                    className="text-white"
                    style={{
                      color: 'white',
                      backgroundColor: iptvScheduleData.length > 100 ? '#20211c80' : '#20211c',
                      border: '1px solid #bdbdbd',
                      borderRadius: '5px',
                      width: '6.8vw',
                      height: '2.4vw',
                      fontSize: '.75vw',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                    onClick={handleAddSlot}
                    disabled={iptvScheduleData.length > 100}
                  >
                    ADD SLOT
                  </CButton>
                </div>
              </div>
              <div
                className="slots-container custom-scrollbar-vertical"
                style={{
                  marginTop: '1vw',
                  maxHeight: '20vw',
                  overflowY: 'auto',
                  padding: '0 .5%',
                }}
              >
                {iptvScheduleData.map((item, idx) => (
                  <IPTVContentSlot
                    key={idx}
                    data={item}
                    slotIndex={idx}
                    error={iptvslotErrorData[idx]}
                    setIptvScheduleData={setIptvScheduleData}
                    iptvScheduleData={iptvScheduleData}
                    channelsMaster={channelsMaster}
                    onDelete={() => handleRemoveSlot(idx)}
                  />
                ))}
              </div>
            </div>
          ) : (
            <div
              className="rounded-1 py-3 mt-4"
              style={{
                padding: '1rem 4%',
                minHeight: '195px',
                backgroundColor: '#eeeeee',
                border: 'solid 0.5px #707070',
                boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.31)',
              }}
            >
              <h4 style={{ fontSize: '1.5vw', fontWeight: '700' }}>PUBLISH</h4>
              <div className="d-flex justify-content-between" style={{ gap: '2vw' }}>
                <div>
                  <div className="d-flex justify-content-start align-items-start">
                    <h6 style={{ fontSize: '.8vw', marginTop: '.75rem' }}>
                      Set your asset publishing time
                    </h6>
                    <div style={{ marginLeft: '2vw' }}>
                      <div
                        className="d-flex justify-content-start align-items-center rounded-1 overflow-hidden"
                        style={{ border: '0.5px solid #707070' }}
                      >
                        {!`${content?.video_type}`.includes('LIVE') && (
                          <CCol>
                            <CFormCheck
                              className="pricing-cformcheck"
                              type="radio"
                              id="1"
                              label="PUBLISH NOW"
                              value="IMMEDIATE"
                              checked={publishPolicy === 'IMMEDIATE'}
                              onClick={(e) => handlePublishPolicy(e)}
                            />
                          </CCol>
                        )}
                        <CCol className={`center-form-check`}>
                          <CFormCheck
                            className="pricing-cformcheck"
                            type="radio"
                            id="2"
                            label="PUBLISH LATER"
                            value="SCHEDULED"
                            checked={publishPolicy === 'SCHEDULED'}
                            onClick={(e) => handlePublishPolicy(e)}
                          />
                        </CCol>
                        <CCol>
                          <CFormCheck
                            className="pricing-cformcheck"
                            type="radio"
                            id="3"
                            label="SAVE IN DRAFT"
                            value="DRAFT"
                            checked={publishPolicy === 'DRAFT'}
                            onChange={(e) => handlePublishPolicy(e)}
                          />
                        </CCol>
                      </div>

                      {publishPolicy === 'SCHEDULED' &&
                      !`${content?.video_type}`.includes('LIVE') ? (
                        <div style={{ marginTop: '1rem' }}>
                          <h6 style={{ fontSize: '.65vw' }}>Publishing Date & Time</h6>
                          <div className="d-flex">
                            <div>
                              <DatePicker
                                className="date-picker-pricing"
                                onChange={setScheduledDate}
                                value={scheduledDate}
                                minDate={scheduledDate ? '' : new Date()}
                                format="dd/MM/y"
                                calendarIcon={<DateIcon />}
                              />
                            </div>
                            <div style={{ marginLeft: '2.1vw', position: 'relative' }}>
                              <TimePicker time={scheduledTime} setTime={setScheduledTime} />
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div>
                    {publishPolicy === 'SCHEDULED' && (
                      <>
                        {`${content?.video_type}`.includes('LIVE') && (
                          <div className="d-flex flex-wrap" style={{ marginTop: '1rem' }}>
                            <div>
                              <h6 style={{ fontSize: '.65vw' }}>START TIME</h6>
                              <div className="d-flex">
                                <div>
                                  <DatePicker
                                    className="date-picker-pricing"
                                    onChange={setScheduledDate}
                                    value={scheduledDate}
                                    minDate={scheduledDate ? '' : new Date()}
                                    format="dd/MM/y"
                                    calendarIcon={<DateIcon />}
                                  />
                                </div>
                                <div style={{ marginLeft: '.5vw', position: 'relative' }}>
                                  <TimePicker time={scheduledTime} setTime={setScheduledTime} />
                                </div>
                              </div>
                            </div>
                            {`${content?.video_type}` === 'LIVE' && (
                              <div style={{ marginLeft: '1vw' }}>
                                <h6 style={{ fontSize: '.65vw' }}>END TIME</h6>
                                <div className="d-flex">
                                  <div>
                                    <DatePicker
                                      className="date-picker-pricing"
                                      onChange={setLiveExpiryDate}
                                      value={liveExpiryDate}
                                      minDate={scheduledDate}
                                      format="dd/MM/y"
                                      calendarIcon={<DateIcon />}
                                    />
                                  </div>
                                  <div style={{ marginLeft: '.5vw', position: 'relative' }}>
                                    <TimePicker time={liveExpiryTime} setTime={setLiveExpiryTime} />
                                  </div>
                                </div>
                                <div className="message-text error-message">
                                  <p>{errorData.date}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div style={{ width: '37%', textAlign: 'left' }}>
                  <div>
                    {publishPolicy === 'IMMEDIATE' && (
                      <p style={{ fontSize: '.65vw' }}>
                        <img
                          src={RocketIcon}
                          alt=""
                          style={{ width: '16px', marginRight: '.85vw' }}
                        />
                        Publish your content <b>immediately</b> after you click the {"'"}{' '}
                        <b> Save{"'"}</b> button.
                      </p>
                    )}
                    {publishPolicy === 'SCHEDULED' && (
                      <p style={{ fontSize: '.65vw' }}>
                        <img
                          src={CalendarIcon}
                          alt=""
                          style={{ width: '30px', marginRight: '.85vw' }}
                        />
                        Publish your content from a future <b>Date and Time</b>.
                      </p>
                    )}
                    {publishPolicy === 'DRAFT' && (
                      <p style={{ fontSize: '.65vw' }}>
                        <img
                          src={SaveIcon}
                          alt=""
                          style={{ width: '29px', marginRight: '.85vw' }}
                        />
                        Save the asset/content in the <b>Draft</b> and publish it whenever you want.
                      </p>
                    )}
                  </div>
                  <div style={{ marginTop: '1.5vw' }}>
                    <div>
                      <CFormCheck
                        className="expiry-datetime-form-check black-tick-checkbox"
                        id="flexCheckDefault"
                        label="Expiry Date & Time"
                        checked={expiryEnable}
                        onChange={handleExpiryDate}
                      />
                    </div>
                    {expiryEnable && (
                      <div className="d-flex">
                        <div>
                          <DatePicker
                            className="date-picker-pricing"
                            onChange={setExpiryDate}
                            value={expiryDate}
                            minDate={
                              publishPolicy === 'SCHEDULED'
                                ? scheduledDate
                                : expiryDate
                                ? ''
                                : new Date()
                            }
                            calendarIcon={<DateIcon />}
                            format="dd/MM/y"
                            disabled={!expiryEnable}
                          />
                        </div>
                        <div style={{ marginLeft: '2.1vw', position: 'relative' }}>
                          <TimePicker time={expiryTime} setTime={setExpiryTime} />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div
            className={`mt-3 pr-5 mb-3 d-md-flex ${
              isEdit ? 'justify-content-md-between' : 'justify-content-md-end'
            } `}
          >
            {/* {isEdit && <CFormText>*Active Artist/Venue are Visible</CFormText>} */}
            <div style={{ marginLeft: 'auto' }}>
              <CButton
                className=""
                style={{
                  color: '#3a3838',
                  backgroundColor: 'white',
                  marginRight: '2rem',
                  border: '1px solid #bdbdbd',
                  borderRadius: '5px',
                }}
                onClick={() => cancelModal(true)}
              >
                Cancel
              </CButton>
              <CButton
                className="text-white"
                onClick={handlePublish}
                style={{
                  color: 'white',
                  backgroundColor: '#20211c',
                  border: '1px solid #bdbdbd',
                  borderRadius: '5px',
                }}
                disabled={createContentLoading || updateContentLoading}
              >
                Save & Next
              </CButton>
            </div>
          </div>
        </div>
      </CCard>
    </>
  )
}

export default PricingAndPublish
